import { cn } from '@/utils/cn'

type Props = {
  currentMode: 'dark' | 'light'
  onSwitchMode: (mode: 'dark' | 'light') => void
}

export function AppearanceCoresModeSection({ currentMode, onSwitchMode }: Props) {
  return (
    <div className="glass-card p-5 space-y-4">
      <div>
        <h3 className="text-text-primary font-semibold text-sm">Modo de Tema</h3>
        <p className="text-text-muted text-[11px] mt-0.5">
          Selecione o tema base e personalize as cores para cada modo de exibição.
        </p>
      </div>

      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => onSwitchMode('dark')}
          className={cn(
            'flex-1 flex items-center gap-3 px-4 py-4 rounded-xl border transition-all text-left group',
            currentMode === 'dark'
              ? 'border-accent bg-accent/10 shadow-lg shadow-accent/20'
              : 'border-white/[0.08] bg-white/[0.03] hover:border-white/[0.15] hover:bg-white/[0.06]',
          )}
        >
          <div className="w-10 h-10 rounded-lg bg-[#0c0d0e] border border-white/[0.08] flex items-center justify-center text-lg shrink-0">
            🌙
          </div>
          <div>
            <p className={cn('text-sm font-bold', currentMode === 'dark' ? 'text-accent' : 'text-text-primary')}>
              Dark Mode
            </p>
            <p className="text-[10px] text-text-muted mt-0.5">Fundo escuro, ideal para uso noturno</p>
          </div>
          {currentMode === 'dark' && (
            <div className="ml-auto w-5 h-5 rounded-full bg-accent flex items-center justify-center shrink-0">
              <svg width="9" height="9" viewBox="0 0 8 8" fill="none">
                <path d="M1.5 4L3.2 5.7L6.5 2.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          )}
        </button>

        <button
          type="button"
          onClick={() => onSwitchMode('light')}
          className={cn(
            'flex-1 flex items-center gap-3 px-4 py-4 rounded-xl border transition-all text-left group',
            currentMode === 'light'
              ? 'border-accent bg-accent/10 shadow-lg shadow-accent/20'
              : 'border-white/[0.08] bg-white/[0.03] hover:border-white/[0.15] hover:bg-white/[0.06]',
          )}
        >
          <div className="w-10 h-10 rounded-lg bg-white border border-black/[0.08] flex items-center justify-center text-lg shrink-0">
            ☀️
          </div>
          <div>
            <p className={cn('text-sm font-bold', currentMode === 'light' ? 'text-accent' : 'text-text-primary')}>
              Light Mode
            </p>
            <p className="text-[10px] text-text-muted mt-0.5">Fundo claro, ideal para uso diurno</p>
          </div>
          {currentMode === 'light' && (
            <div className="ml-auto w-5 h-5 rounded-full bg-accent flex items-center justify-center shrink-0">
              <svg width="9" height="9" viewBox="0 0 8 8" fill="none">
                <path d="M1.5 4L3.2 5.7L6.5 2.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          )}
        </button>
      </div>

      <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/[0.03] border border-white/[0.05]">
        <div className={cn('w-2 h-2 rounded-full', currentMode === 'dark' ? 'bg-indigo-400' : 'bg-amber-400')} />
        <p className="text-[11px] text-text-muted">
          Editando cores para o{' '}
          <strong className="text-text-primary">
            {currentMode === 'dark' ? 'Dark Mode 🌙' : 'Light Mode ☀️'}
          </strong>
          . As alterações manuais abaixo se aplicam ao modo selecionado.
        </p>
      </div>
    </div>
  )
}
